<template>
  <!-- Page Content -->
  <div class="login-page">
    <div class="login-page-content content">
      <!-- Login Content -->
      <div class="login-content">
        <div class="align-items-center justify-content-center">
          <div class="login-right">
            <div class="login-header text-center">
                <img src="@/assets/img/logo.png" alt="logo" class="img-fluid" style="width: 120px;"/>
                <h3>Bienvenido! Un gusto verte de nuevo</h3>
            </div>
            <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
              <div class="input-block">
                <label class="focus-label"
                  >Usuario <span class="label-star"> *</span></label
                >
                <Field
                  name="email"
                  class="form-control"
                  :class="{ 'is-invalid': errors.email }"
                  v-model="email"
                  />
                  <!-- value="example@dreamstechnologies.com" -->
                <div class="invalid-feedback">{{ errors.email }}</div>
                <div class="emailshow text-danger" id="email"></div>
              </div>
              <div class="input-block">
                <label class="focus-label"
                  >Contraseña <span class="label-star"> *</span></label
                >
                <div class="position-relative">
                  <Field
                    name="password"
                    :type="showPassword ? 'text' : 'password'"
                    class="form-control pass-input mt-2"
                    :class="{ 'is-invalid': errors.password }"
                    v-model="pass"
                    />
                    <!-- value="123456" -->
                  <span @click="toggleShow" class="toggle-password2">
                    <i
                      :class="{
                        'fas fa-eye': showPassword,
                        'fas fa-eye-slash': !showPassword,
                      }"
                    ></i>
                  </span>
                  <div class="invalid-feedback">{{ errors.password }}</div>
                  <div class="emailshow text-danger" id="password"></div>
                </div>
              </div>
              <button type="submit" :disabled="loading" class="btn btn-agv w-100 btn-lg login-btn d-flex align-items-center justify-content-center">
                Ingresar
                <i class="feather-arrow-right ms-2" v-if="!loading"></i>
                <VProgressCircular v-if="loading" indeterminate color="primary" :width="2"></VProgressCircular>
              </button>
              <div class="row">
                <!-- <div class="col-sm-4 text-sm-end">
                  <router-link class="forgot-link" to="/forgot-password"
                    >Lost Password?</router-link
                  >
                </div> -->
              </div>
            </Form>
          </div>
        </div>
      </div>
      <!-- /Login Content -->
    </div>
  </div>

  <!-- /Page Content -->
</template>

<style>

    .login-page{
        background-color: #482775;
        height: 100vh;
    }

    .login-page-content {
        margin: 0 auto;
        max-width: 480px;
        padding-top: 160px;
    }

    .login-content{
        background-color: #fff;
        border-radius: 30px;
        margin: auto;
        padding: 30px;
        box-shadow: 0px 8px 16px 0px rgba(142, 141, 208, 0.12);
        width: 100%;
    }

    .login-header img {
        margin-bottom: 15px;
    }

    .login-header {
        margin-bottom: 20px;
    }

    .login-header h3 {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 9px;
        color: #1B1B1B;
    }

    .input-block{
        position: relative;
        margin-bottom: 1.25rem;
    }

    .login-content .focus-label {
        font-weight: 600;
        color: #131135;
    }

    .login-content .form-control {
        height: 40px;
    }

    .label-star {
        color: #FF3B30;
    }

    .login-page .toggle-password2 {
        position: absolute;
        right: 17px;
        top: 10px;
        color: gray;
        cursor: pointer;
        font-size: 1rem;
    }

    .login-page .login-btn:hover {
        color: #482775;
        border: 1px solid #482775;
    }

    .login-page .login-btn {
        font-size: 16px;
        font-weight: 600;
        background: #482775;
        border: 1px solid #482775;
        border-radius: 5px;
        padding: 10px;
        color: #fff;
    }
</style>


<script>
import { Form, Field } from "vee-validate";
import axiosIns from '@/plugins/axios.js';
import * as Yup from "yup";
import { router } from "@/router";
export default {
  components: {
    Form,
    Field,
  },
  data() {
    return {
      showPassword: false,
      password: null,
      emailError: "",
      passwordError: "",

      email:null,
      pass:null,
      loading: false,
    };
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    onSubmit(){
      const yo = this
      const data=JSON.stringify({
        'username': yo.email,
        'password': yo.pass,
      });

      const config={
        method:'post',
        url: 'configuracion/api-token-v2/',
        headers:{
          'Content-Type':'application/json'
        },
        data:data,
      };
      yo.loading = true;

      axiosIns(config)
        .then(function(response){
          if (response.status === 200) {
            var u = response.data.access.split('.')
            let usuario = JSON.parse(decodeURIComponent(escape(window.atob(u[1]))))
            const keyPermissions = response.data.permissions.split(".");
            const datosPermissions = JSON.parse(decodeURIComponent(escape(window.atob(keyPermissions[1]))));
            // var datos_usuario=response.data
            localStorage.setItem('userDataAdmin', JSON.stringify({
              'nombres': usuario.name,
              'email': usuario.email,
              'id_usuario': usuario.user_id,
              'rol': usuario.rol,
              'username': usuario.username,
              'dni': usuario.dni,
            }))

            yo.$toastr.success(response.data['message'], 'Éxito')
            // router.push({path: '/admin/principal', replace: true});
            router.replace('/admin/principal')
          }else{
            yo.error = 'Error consulte con su administrador';
            setTimeout(() => {
              yo.error = '';
            }, 4000);
          }
        })
        .catch(function (error) {
          // console.log(error);
          yo.error = 'Usuario y Contraseña invalida';
          setTimeout(() => {
            yo.error = '';
          }, 4000);
          yo.loading = false;
        })
        .finally(function () {
          yo.loading = false;
        });

    },

    // onSubmit(values) {
    //   this.emailError = "";
    //   this.passwordError = "";

    //   let data = localStorage.getItem("storedData");
    //   var Pdata = JSON.parse(data);
    //   const Eresult = Pdata.find(({ email }) => email === values.email);
    //   if (Eresult) {
    //     if (Eresult.password === values.password) {
    //       this.$router.push("/home"); // Use this.$router instead of router
    //     } else {
    //       this.passwordError = "Incorrect password";
    //     }
    //   } else {
    //     this.emailError = "Email is not valid";
    //   }
    // },
  },
  setup() {
    let users = localStorage.getItem("storedData");
    if (users === null) {
      let password = [
        {
          email: "example@correo.com",
          password: "123456",
        },
      ];
      const jsonData = JSON.stringify(password);
      localStorage.setItem("storedData", jsonData);
    }
    const schema = Yup.object().shape({
      email: Yup.string().required("Usuario es obligatorio"),
      password: Yup.string()
        // .min(6, "Contras")
        .required("Contraseña es obligatoria"),
    });
    return {
      schema,
    };
  },
};

</script>
